// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Airplay, Settings, BarChart2, Box, Eye } from "lucide-react";

// const Navdata = () => {
//   const history = useNavigate();
//   const [isCurrentState, setIsCurrentState] = useState("");

//   const menuItems: any = [
//     {
//       label: "Menu",
//       isHeader: true,
//     },
//     {
//       id: "dashboard",
//       label: "Dashboard",
//       link: "/dashboard",
//       icon: <Airplay className="icons" />,
//       click: function (e: any) {
//         e.preventDefault();
//         history("/dashboard");
//         setIsCurrentState("Dashboard");
//       },
//     },
//     {
//       id: "store-settings",
//       label: "Store Settings",
//       link: "/store-settings",
//       icon: <Settings className="icons" />,
//       click: function (e: any) {
//         e.preventDefault();
//         history("/store-settings");
//         setIsCurrentState("Store Settings");
//       },
//     },
//     {
//       id: "analytics",
//       label: "Analytics",
//       link: "/analytics",
//       icon: <BarChart2 className="icons" />,
//       click: function (e: any) {
//         e.preventDefault();
//         history("/analytics");
//         setIsCurrentState("Analytics");
//       },
//     },
//     {
//       id: "manage-products",
//       label: "Manage Products",
//       link: "/manage-products",
//       icon: <Box className="icons" />,
//       click: function (e: any) {
//         e.preventDefault();
//         history("/manage-products");
//         setIsCurrentState("Manage Products");
//       },
//     },
//     {
//       id: "view-store",
//       label: "View Store",
//       link: "/view-store",
//       icon: <Eye className="icons" />,
//       click: function (e: any) {
//         e.preventDefault();
//         history("/view-store");
//         setIsCurrentState("View Store");
//       },
//     },
//   ];

//   return <React.Fragment>{menuItems}</React.Fragment>;
// };
// export default Navdata;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Airplay, Settings, BarChart2, Box, Eye, Layers, ShieldCheck, Users } from "lucide-react";
import Axios from "../Common/api/axiosConfig";
import { onActiveStoreChange } from "../utils/storeHelper";

const Navdata = () => {
  const history = useNavigate();
  const [isCurrentState, setIsCurrentState] = useState("");
  const [storeUrl, setStoreUrl] = useState<string | null>(null);
  const [userRole, setUserRole] = useState<string>("tenant");
  const [hasImpersonation, setHasImpersonation] = useState<boolean>(false);

  // Fetch user's store URL when component mounts
  useEffect(() => {
    const fetchStoreUrl = async () => {
      try {
        // Get userData from localStorage and parse it
        const userDataString = localStorage.getItem("userData");

        if (localStorage.getItem("adminBackupToken")) {
          setHasImpersonation(true);
        }

        if (!userDataString) {
          console.error("User data not found in localStorage");
          return;
        }

        const userData = JSON.parse(userDataString);
        if (userData.role) {
          setUserRole(userData.role);
        }

        const userId = userData._id || userData.id;

        if (!userId) {
          console.error("User ID not found in user data");
          return;
        }

        // Fetch store data using userId
        const response = await Axios.get(`/store/${userId}`);
        const storeData = response.data.store;

        if (storeData && storeData.url) {
          setStoreUrl(storeData.url);
        }
      } catch (error: any) {
        console.error("Error fetching store URL:", error);
        // Don't show error to user, just don't set the store URL
        // This allows the menu to still work, just redirects to create-store if clicked
      }
    };

    fetchStoreUrl();
    const unsubscribe = onActiveStoreChange(() => {
      fetchStoreUrl();
    });
    return () => unsubscribe();
  }, []);

  const menuItems: any = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "Dashboard",
      link: "/dashboard",
      icon: <Airplay className="icons" />,
      click: function (e: any) {
        e.preventDefault();
        history("/dashboard");
        setIsCurrentState("Dashboard");
      },
    },
    {
      id: "store-settings",
      label: "Store Settings",
      link: "/store-settings",
      icon: <Settings className="icons" />,
      click: function (e: any) {
        e.preventDefault();
        history("/store-settings");
        setIsCurrentState("Store Settings");
      },
    },
    {
      id: "analytics",
      label: "Analytics",
      link: "/analytics",
      icon: <BarChart2 className="icons" />,
      click: function (e: any) {
        e.preventDefault();
        history("/analytics");
        setIsCurrentState("Analytics");
      },
    },
    {
      id: "manage-products",
      label: "Manage Products",
      link: "/manage-products",
      icon: <Box className="icons" />,
      click: function (e: any) {
        e.preventDefault();
        history("/manage-products");
        setIsCurrentState("Manage Products");
      },
    },
    {
      id: "warranty-registrations",
      label: "Warranty Registrations",
      link: "/warranty-registrations",
      icon: <ShieldCheck className="icons" />,
      click: function (e: any) {
        e.preventDefault();
        history("/warranty-registrations");
        setIsCurrentState("Warranty Registrations");
      },
    },
    {
      id: "categories",
      label: "Categories",
      link: "/store-settings#categories",
      icon: <Layers className="icons" />,
      click: function (e: any) {
        e.preventDefault();
        history("/store-settings#categories");
        setIsCurrentState("Categories");
        setTimeout(() => {
          const el = document.getElementById("categories");
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
          }
        }, 150);
      },
    },
    {
      id: "view-store",
      label: "View Store",
      link: storeUrl?.includes(".") ? `https://${storeUrl}` : `/${storeUrl || "shop"}`,
      icon: <Eye className="icons" />,
      click: function (e: any) {
        e.preventDefault();
        if (storeUrl) {
          const targetUrl = storeUrl.includes(".")
            ? `https://${storeUrl}`
            : `/${storeUrl}`;
          window.open(targetUrl, "_blank");
        }
      },
    },
    ...(userRole === "superadmin" || hasImpersonation
      ? [
          {
            label: "Administration",
            isHeader: true,
          },
          {
            id: "admin-tenants",
            label: "Tenant Management",
            link: "/admin/tenants",
            icon: <Users className="icons" />,
            click: function (e: any) {
              e.preventDefault();
              history("/admin/tenants");
              setIsCurrentState("Tenant Management");
            },
          },
        ]
      : []),
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
